import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Eye } from "lucide-react";
import { useStartViewAs } from "@/lib/coachQueries";
import { setViewAsSession } from "@/lib/viewAsSession";

/**
 * Master v5 Prompt 17 — starts a real ViewAsSession against one EXACT
 * WorkspaceMembership and navigates the coach straight into that
 * client's own Home, banner already showing. Never a role-level
 * "view as any client_member" shortcut.
 */
export function ViewAsClientButton({ workspaceId, workspaceTitle, memberId, memberName, className, testId }) {
  const navigate = useNavigate();
  const startViewAs = useStartViewAs(workspaceId);

  async function handleClick() {
    try {
      const result = await startViewAs.mutateAsync(memberId);
      setViewAsSession({
        vas_id: result.vas_id, session_token: result.session_token, expires_at: result.expires_at,
        workspace_id: workspaceId, workspace_title: workspaceTitle,
        target_membership_id: result.target_membership_id, target_member_name: memberName,
      });
      navigate(`/rehearsal-room/w/${workspaceId}/home`);
    } catch (err) {
      toast.error(err.message === "request_failed" ? "Could not start View as Client" : err.message);
    }
  }

  return (
    <button
      onClick={handleClick}
      disabled={startViewAs.isPending}
      className={className || "flex items-center gap-1.5 text-sm font-medium border border-ink/15 rounded-full px-3 py-1.5 text-ink hover:bg-ink/5 transition-colors disabled:opacity-50"}
      data-testid={testId || `view-as-client-button-${memberId}`}
    >
      <Eye size={14} /> {startViewAs.isPending ? "Starting…" : `View as ${memberName || "Client"}`}
    </button>
  );
}
